exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-weight: bold;\n  padding: 5px 10px;\n  background: #dee4e4;\n  color: #2b6552;\n  cursor: pointer; }\n  :host:hover {\n    background: #ecf0f0;\n    color: #3b896e; }\n  :host.blue {\n    background: #E0E6EB;\n    color: #053755; }\n    :host.blue:hover {\n      background: #e3e9ed;\n      color: #095785; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/button/button.component.scss
// module id = 471
// module chunks = 1